import FocusableIconButton from '@components/FocusableIconButton';
import PaymentButton from '@components/PaymentButton';
import { usePaymentSelectionContext } from '@context/Payment/PaymentSelection';
import { useEffect } from 'react';

import { makeExistingPayment, NEW_PAYMENT } from '../../../focuskey';

import * as styles from './styles';

const RegisteredPaymentButtons = () => {
  const { paymentMethods, setButtonFocus, goNextStep, goPaymentRegistration } =
    usePaymentSelectionContext();

  useEffect(() => {
    setButtonFocus();
  }, [setButtonFocus]);

  return (
    <div>
      <p css={styles.title}>등록된 결제 수단</p>
      <div css={styles.buttonContainer}>
        {paymentMethods?.map((paymentMethod, index) => (
          <PaymentButton
            key={index}
            paymentMethod={paymentMethod}
            focusKey={makeExistingPayment(index)}
            onEnterPress={() => goNextStep(paymentMethod)}
          />
        ))}
        <FocusableIconButton
          focusKey={NEW_PAYMENT}
          onEnterPress={goPaymentRegistration}
          iconType={'plus'}
        >
          새로운 결제수단 등록하기
        </FocusableIconButton>
      </div>
    </div>
  );
};

export default RegisteredPaymentButtons;
